


























































import Vue from 'vue'
import Analytics from '@/services/Analytics'
import { Plan } from '@/types/Subscription.interface'
import { randomKey } from '@/utility/helpers'
export default Vue.extend({
    props: {
        payload: {
            type: Object,
            default: null,
            required: true
        },
        todaysCharge: {
            type: String,
            default: null,
            required: false
        }
    },
    data() {
        return {
            step: 1
        }
    },
    created() {
        //  Embed script for calendly
        const embedCalendly = document.createElement('script')
        embedCalendly.setAttribute(
            'src',
            'https://assets.calendly.com/assets/external/widget.js'
        )
        embedCalendly.setAttribute('async', 'async')
        document.head.appendChild(embedCalendly)

        //  Embed calendly css stylesheet
        const calendlyCSS = document.createElement('link')
        calendlyCSS.setAttribute(
            'href',
            'https://assets.calendly.com/assets/external/widget.css'
        )
        calendlyCSS.setAttribute('rel', 'stylesheet')
        document.head.appendChild(calendlyCSS)
    },
    computed: {
        currentPlan(): Plan {
            return this.$store.getters.plan
        },
        isUpgrade(): Function {
            return this.$store.getters.isUpgrade
        }
    },
    methods: {
        next(): void {
            //  Increment step counter
            this.step = 3

            //  Route to inbox
            this.$router.push('/inbox')
        },
        async subscriptionUpdate() {
            //  Grab our plan from the payload
            const plan = this.payload.plan || this.currentPlan

            //  Grab our addons and users from our payload
            const users = this.payload.users

            //  Construct the upgrade payload
            const payload = {
                users: users,
                ...plan
            }

            //  Either we are going to a higher plan, or going from monthly to annual
            const upgrade = this.isUpgrade(plan)

            //  Attach the selected discount if available
            if (this.discountCode) payload.discount = this.discountCode

            //  Go to step 2
            this.step = 2

            //  Send the request to the API
            const subscription = await this.$store.dispatch('subscriptionUpdate', payload)

            //  If it fails, just set the key to a new one to reset the form
            if (!subscription) return (this.key = randomKey())

            //  If it was successful and we receive the notification, do this
            let msg = payload.discount
                ? `Discount Code applied! Enjoy your discount of ${subscription.discount.coupon.percent_off}%!`
                : `Subscription ${upgrade ? 'Upgraded' : 'Downgraded'} Successfully`

            //  Push toast notification
            this.$store.commit('appNotificationBarSet', {
                message: msg,
                type: 'success'
            })

            //  Track in google analytics
            // Analytics.gaEvent({
            //     name: 'User Payment Complete',
            //     properties: { customer: this.$store.getters.user.id }
            // })

            //  Set to null so we know that we are updating and not just putting in discount
            this.discountCode = null

            //  We're done so reroute and go to last page
            this.next()
        }
    }
})
